export default __webpack_public_path__ + "static/media/guidance.d9858bc9.jpg";